module.exports = require("events");


//////////////////
// WEBPACK FOOTER
// external "events"
// module id = 318
// module chunks = 0